import React from "react";

import { Container } from "@components/Container/Container";
import styles from "./styles.module.scss";
import { ImageField } from "@helpers/interfaces/image";
import { Box } from "@components/Box/Box";
import { LinkField } from "@helpers/interfaces/link";
import { Link } from "@components/Link/Link";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { Heading } from "@components/Heading/Heading";
import { Text } from "@components/Text/Text";
import classnames from "classnames";
import { Module } from "@components/Module/Module";

export interface GraphicTeaserProps {
  teaser: {
    Image: ImageField;
    BackgroundColor?: string;
    BackgroundImage?: ImageField;
    TextColor?: string;
    ImageOverEdge?: boolean;
    Link?: LinkField;
    TeaserText?: string;
    Key: string;
  };
}

const hex = (value?: string): string => {
  return value ? (value.startsWith("#") ? value : `#${value}`) : "";
};

const TeaserContent: React.FC<GraphicTeaserProps> = ({ teaser }) => {
  return (
    <>
      <Box className={styles.graphicTeaserTextBox}>
        {teaser.TeaserText && (
          <Heading
            as="h2"
            className={styles.heading}
            style={{ color: `${hex(teaser.TextColor)}` }}
          >
            {teaser.TeaserText}
          </Heading>
        )}
        {teaser.Link && teaser.Link.Name !== teaser.Link.Url && (
          <Text
            className={styles.text}
            style={{ color: `${hex(teaser.TextColor)}` }}
          >
            {teaser.Link.Name}
          </Text>
        )}
      </Box>
      {teaser.Image && (
        <Box
          className={classnames(
            styles.graphicTeaserImg,
            teaser.ImageOverEdge && styles.graphicTeaserImgOveredge
          )}
        >
          <UmbracoImage image={teaser.Image} />
        </Box>
      )}
    </>
  );
};

const GraphicTeaser: React.FC<GraphicTeaserProps> = ({ teaser }) => {
  return (
    <Module animate>
      <Container>
        {teaser.Link && teaser.Link.Url ? (
          <Link
            href={teaser.Link.Url}
            {...(teaser.Link.Target && { target: teaser.Link.Target })}
            className={styles.graphicTeaser}
            {...(teaser.BackgroundColor && {
              style: {
                backgroundColor: `${hex(teaser.BackgroundColor)}`,
                color: `${hex(teaser.TextColor)}`,
                ...(teaser.BackgroundImage && {
                  backgroundImage: `url(${teaser.BackgroundImage.FullUrl})`,
                  backgroundSize: "cover"
                })
              }
            })}
          >
            <TeaserContent teaser={teaser} />
          </Link>
        ) : (
          <Box
            className={styles.graphicTeaser}
            {...(teaser.BackgroundColor && {
              style: {
                backgroundColor: teaser.BackgroundColor,
                color: teaser.TextColor
              }
            })}
          >
            <TeaserContent teaser={teaser} />
          </Box>
        )}
      </Container>
    </Module>
  );
};

export { GraphicTeaser };
